// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import { useNavigate } from "react-router-dom";
// import APICall from "../../Utility/APICall";
// import { paths } from "../../Utility/Constants";
// import { useAuth } from "../../Utility/AuthProvider";
// import Lottie from "lottie-react";
// import loaderAnimation from "../../assets/animations/loader.json";
// import GenericTable from "../GenericTable";
// import Switch from "react-switch";
// import {useAgreements} from "../../Contexts/AgreementsContext";

// function Agreements() {
//   const { jwt } = useAuth();
//   const navigate = useNavigate();

//   // --- STATE REFACTOR ---
//   // 1. A master list to hold ALL agreements from the single API call.
//   const [allAgreements, setAllAgreements] = useState([]);

//   // State for the toggle remains the same.
//   const [showActiveOnly, setShowActiveOnly] = useState(true);

//   // Loading and error states.
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // Note: Pagination/infinite scroll states are removed as they are not needed for this approach.

//   // --- HELPER FUNCTIONS (No changes) ---
//   const calculateTenure = (createdDate, vacatingDate) => {
//     const created = new Date(createdDate);
//     const vacating = new Date(vacatingDate);
//     const years = vacating.getFullYear() - created.getFullYear();
//     let months = vacating.getMonth() - created.getMonth() + years * 12;
//     if (months < 0) months += 12;
//     const displayYears = Math.floor(months / 12);
//     const displayMonths = months % 12;
//     return `${displayYears > 0 ? `${displayYears} year ` : ""}${displayMonths > 0 ? `${displayMonths} months` : displayYears === 0 ? "0 month" : ""}`.trim();
//   };

//   const processAgreements = (newAgreements) => {
//     return newAgreements.map((agreement) => ({
//       ...agreement,
//       id:
//         agreement.entity_id ||
//         `agreement-${Date.now()}-${Math.random().toString(16).slice(2)}`,
//       tenure: calculateTenure(agreement.created, agreement.vacating_on),
//     }));
//   };

//   // --- SIMPLIFIED DATA FETCHING ---
//   const fetchAllAgreements = useCallback(async () => {
//     setLoading(true);
//     setError("");

//     try {
//       // 2. Always fetch ALL agreements.
//       const apiUrl = `${paths.agreement.fetch}?active=all`;

//       const response = await APICall("GET", apiUrl, undefined, undefined, jwt);
//       console.log(`Agreements API Response (All):`, response);

//       if (
//         response &&
//         response.status === "success" &&
//         Array.isArray(response.response)
//       ) {
//         const fetchedAgreements = processAgreements(response.response);
//         // Sort once and store in the master list.
//         const sortedAgreements = fetchedAgreements.sort(
//           (a, b) => new Date(b.created) - new Date(a.created) // Sort by most recent created
//         );
//         setAllAgreements(sortedAgreements);
//         console.log(
//           "All agreements fetched and processed::::::",
//           sortedAgreements
//         );
//       } else {
//         setError(response?.message || "Failed to parse agreement data.");
//         setAllAgreements([]);
//       }
//     } catch (err) {
//       setError(err.message || "Failed to fetch agreements");
//       setAllAgreements([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [jwt]); // Dependency array is now much simpler.

//   // --- EFFECT FOR INITIAL FETCH ---
//   // 3. This now only runs ONCE on component mount.
//   useEffect(() => {
//     if (jwt) {
//       fetchAllAgreements();
//     }
//   }, [jwt, fetchAllAgreements]);

//   // --- CLIENT-SIDE FILTERING WITH useMemo ---
//   // 4. This is the core of the optimization.
//   // It filters the `allAgreements` list without re-fetching.
//   // `useMemo` ensures this only recalculates when `allAgreements` or `showActiveOnly` changes.
//   const filteredAgreements = useMemo(() => {
//     if (showActiveOnly) {
//       return allAgreements.filter((agreement) => agreement.active === true);
//     }
//     return allAgreements; // If toggle is off, show all
//   }, [allAgreements, showActiveOnly]);

//   // --- SIMPLIFIED TOGGLE HANDLER ---
//   // 5. This no longer triggers an API call. It just flips the state.
//   const handleToggle = (checked) => {
//     setShowActiveOnly(checked);
//   };

//   // --- TABLE DEFINITION (No changes in columns) ---
//   const columns = [
//     { id: "serialNo", label: "Record No.", minWidth: 80 },
//     { id: "buildingName", label: "Building", minWidth: 150 },
//     { id: "unitName", label: "Unit", minWidth: 120 },
//     { id: "tenure", label: "Tenure", minWidth: 120 },
//     { id: "created", label: "Created On", minWidth: 100 },
//     { id: "vacatingOn", label: "Vacating On", minWidth: 100 },
//     { id: "updatedOn", label: "Last Updated", minWidth: 100 },
//     { id: "status", label: "Status", minWidth: 100 },
//   ];

//   // The `rows` now map over the `filteredAgreements` derived state.
//   const rows = filteredAgreements.map((agreement, index) => {
//     const today = new Date();
//     const vacatingDate = new Date(agreement.vacating_on);
//     const isVacatingDatePast = vacatingDate < today;
//     const vacatingOnColor =
//       isVacatingDatePast && !agreement.active ? "red" : "inherit";

//     return {
//       ...agreement,
//       serialNo: index + 1,
//       buildingName: agreement.building_name || "N/A",
//       unitName: agreement.unit_name || "N/A",
//       created: new Date(agreement.created).toLocaleDateString(),
//       vacatingOn: (
//         <span style={{ color: vacatingOnColor }}>
//           {new Date(agreement.vacating_on).toLocaleDateString()}
//         </span>
//       ),
//       updatedOn: agreement.updated
//         ? new Date(agreement.updated).toLocaleDateString()
//         : new Date(agreement.created).toLocaleDateString(),
//       status: (
//         <span style={{ color: agreement.active ? "green" : "red" }}>
//           {agreement.active ? "Active" : "Inactive"}
//         </span>
//       ),
//     };
//   });

//   const onRowClick = (row) => {
//     // 'row' is the full object for the clicked row, passed from GenericTable
//     if (row && row.unit_id) {
//       // Extract the unit_id from the row object
//       const unitId = row.unit_id;
//       console.log(`Row clicked. Navigating to unit ID: ${unitId}`);

//       // Navigate using the extracted ID
//       navigate(`/dashboard/my-properties/${unitId}`);
//     } else {
//       console.error(
//         "Row click failed: The clicked row is missing a unit_id.",
//         row
//       );
//       // Optionally show an alert to the user
//       alert(
//         "Could not navigate. Unit information is missing for this agreement."
//       );
//     }
//   };

//   // /dashboard/my-properties/:unitId

//   // --- RENDER LOGIC ---
//   return (
//     <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
//       {/* <h1 className="text-xl font-bold text-gray-800 mb-6">Agreements</h1> */}

//       <div className="flex items-center pb-8">
//         <span className="mr-2 text-sm text-gray-600">Show Active Only</span>
//         <Switch
//           checked={showActiveOnly}
//           onChange={handleToggle}
//           onColor="#86d3ff"
//           onHandleColor="#2693ee"
//           handleDiameter={24}
//           uncheckedIcon={false}
//           checkedIcon={false}
//           boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
//           activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
//           height={28}
//           width={56}
//           className="react-switch"
//         />
//       </div>

//       <GenericTable
//         columns={columns}
//         rows={rows}
//         rowKeyField="id"
//         // Use a single loading state. Show loader only on initial load.
//         loading={loading}
//         loaderAnimation={loaderAnimation}
//         onRowClick={onRowClick}
//       />

//       {!loading && !error && (
//         <p className="text-center text-gray-500 py-4 text-sm">
//           Showing {rows.length} of {allAgreements.length} total agreements.
//         </p>
//       )}

//       {error && !loading && (
//         <p className="text-red-500 text-center py-10 text-lg">{error}</p>
//       )}

//       {!loading && allAgreements.length === 0 && !error && (
//         <p className="text-gray-500 text-center py-10">
//           No agreements available.
//         </p>
//       )}
//     </div>
//   );
// }

// export default Agreements;

// import React, { useState, useEffect, useMemo, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAgreementContext } from "./AgreementContext"; // Corrected import path for local context
// import { useAuth } from "../../Utility/AuthProvider";
// import Lottie from "lottie-react";
// import loaderAnimation from "../../assets/animations/loader.json";
// import GenericTable from "../GenericTable";
// import Switch from "react-switch";
// import Filters from "../Common/Filter";

// function Agreements() {
//   const { jwt } = useAuth();
//   const navigate = useNavigate();

//   // --- CONTEXT CONSUMPTION ---
//   const { allAgreements, loading, error, fetchAllAgreements } =
//     useAgreementContext();

//   // --- LOCAL STATE FOR FILTERS ---
//   const [showActiveOnly, setShowActiveOnly] = useState(true);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [activeFilters, setActiveFilters] = useState({
//     buildingIds: [],
//     unitIds: [],
//     tenantIds: [],
//   });

//   // --- DATA FETCH TRIGGER ---
//   useEffect(() => {
//     if (jwt) {
//       fetchAllAgreements();
//     }
//   }, [jwt, fetchAllAgreements]);

//   // --- FILTER HANDLERS ---
//   const handleFilterChange = useCallback((newFiltersFromChild) => {
//     setActiveFilters(newFiltersFromChild);
//   }, []);

//   const handleToggle = (checked) => {
//     setShowActiveOnly(checked);
//   };

//   const handleClearAllFilters = () => {
//     setSearchQuery("");
//     setActiveFilters({ buildingIds: [], unitIds: [], tenantIds: [] });
//     // Note: We don't reset the active/inactive toggle as it's often a primary view preference.
//   };

//   const activeFilterCount = useMemo(() => {
//     let count = 0;
//     if (searchQuery.trim()) count++;
//     count += Object.values(activeFilters).filter(
//       (arr) => arr.length > 0
//     ).length;
//     return count;
//   }, [searchQuery, activeFilters]);

//   // --- CLIENT-SIDE FILTERING LOGIC ---
//   const filteredAgreements = useMemo(() => {
//     if (!allAgreements) {
//       return [];
//     }

//     let data = [...allAgreements]; // Start with the full dataset from context

//     // 1. Apply search query filter
//     if (searchQuery) {
//       const lowercasedQuery = searchQuery.toLowerCase();
//       data = data.filter(
//         (agreement) =>
//           agreement.building_name?.toLowerCase().includes(lowercasedQuery) ||
//           agreement.unit_name?.toLowerCase().includes(lowercasedQuery)
//       );
//     }

//     // 2. Apply the "Active Only" toggle filter
//     if (showActiveOnly) {
//       data = data.filter((agreement) => agreement.active === true);
//     }

//     // 3. Apply the dropdown filters (Building, Unit)
//     if (activeFilters.buildingIds.length > 0) {
//       data = data.filter((agreement) =>
//         activeFilters.buildingIds.includes(agreement.building_id)
//       );
//     }
//     if (activeFilters.unitIds.length > 0) {
//       data = data.filter((agreement) =>
//         activeFilters.unitIds.includes(agreement.unit_id)
//       );
//     }

//     return data;
//   }, [allAgreements, showActiveOnly, activeFilters, searchQuery]);

//   // --- HELPER & CONFIGS (No Changes) ---
//   const calculateTenure = (createdDate, vacatingDate) => {
//     const created = new Date(createdDate);
//     const vacating = new Date(vacatingDate);
//     const years = vacating.getFullYear() - created.getFullYear();
//     let months = vacating.getMonth() - created.getMonth() + years * 12;
//     if (months < 0) months += 12;
//     const displayYears = Math.floor(months / 12);
//     const displayMonths = months % 12;
//     return `${displayYears > 0 ? `${displayYears} year ` : ""}${displayMonths > 0 ? `${displayMonths} months` : displayYears === 0 ? "0 month" : ""}`.trim();
//   };

//   const columns = [
//     { id: "serialNo", label: "Record No.", minWidth: 80 },
//     { id: "buildingName", label: "Building", minWidth: 150 },
//     { id: "unitName", label: "Unit", minWidth: 120 },
//     { id: "tenure", label: "Tenure", minWidth: 120 },
//     { id: "created", label: "Created On", minWidth: 100 },
//     { id: "vacatingOn", label: "Vacating On", minWidth: 100 },
//     { id: "updatedOn", label: "Last Updated", minWidth: 100 },
//     { id: "status", label: "Status", minWidth: 100 },
//   ];

//   const rows = filteredAgreements.map((agreement, index) => {
//     const today = new Date();
//     const vacatingDate = new Date(agreement.vacating_on);
//     const isVacatingDatePast = vacatingDate < today;
//     const vacatingOnColor =
//       isVacatingDatePast && !agreement.active ? "red" : "inherit";

//     return {
//       ...agreement,
//       serialNo: index + 1,
//       buildingName: agreement.building_name || "N/A",
//       unitName: agreement.unit_name || "N/A",
//       tenure: calculateTenure(agreement.created, agreement.vacating_on),
//       created: new Date(agreement.created).toLocaleDateString(),
//       vacatingOn: (
//         <span style={{ color: vacatingOnColor }}>
//           {new Date(agreement.vacating_on).toLocaleDateString()}
//         </span>
//       ),
//       updatedOn: agreement.updated
//         ? new Date(agreement.updated).toLocaleDateString()
//         : new Date(agreement.created).toLocaleDateString(),
//       status: (
//         <span style={{ color: agreement.active ? "green" : "red" }}>
//           {agreement.active ? "Active" : "Inactive"}
//         </span>
//       ),
//     };
//   });

//   const onRowClick = (row) => {
//     if (row && row.unit_id) {
//       navigate(`/dashboard/my-properties/${row.unit_id}`);
//     } else {
//       console.error(
//         "Row click failed: The clicked row is missing a unit_id.",
//         row
//       );
//       alert(
//         "Could not navigate. Unit information is missing for this agreement."
//       );
//     }
//   };

//   // --- RENDER LOGIC ---
//   if (loading && allAgreements === null) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <Lottie
//           animationData={loaderAnimation}
//           style={{ width: 150, height: 150 }}
//         />
//       </div>
//     );
//   }

//   if (error) {
//     return <p className="text-red-500 text-center py-10 text-lg">{error}</p>;
//   }

//   return (
//     <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
//       <div className="filters-container bg-gray-50 rounded-lg border p-4 mb-4">
//         <div className="flex items-center justify-between mb-4">
//           <div className="flex items-center gap-2">
//             <h3 className="text-lg font-medium">Filters</h3>
//             {activeFilterCount > 0 && (
//               <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
//                 {activeFilterCount} active
//               </span>
//             )}
//           </div>
//           {activeFilterCount > 0 && (
//             <button
//               onClick={handleClearAllFilters}
//               className="text-sm font-medium text-red-600 hover:text-red-800"
//             >
//               Clear All
//             </button>
//           )}
//         </div>

//         <div className="mb-4">
//           <input
//             type="text"
//             placeholder="Search by building or unit name..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//           />
//         </div>

//         <Filters
//           onFilterChange={handleFilterChange}
//           selectedFilters={activeFilters}
//           availableFilters={["building", "unit"]}
//         />

//         <div className="border-t mt-4 pt-4 flex items-center">
//           <span className="mr-4 text-sm text-gray-700 font-medium">
//             Agreement Status:
//           </span>
//           <span className="mr-2 text-sm text-gray-600">Show Active Only</span>
//           <Switch
//             checked={showActiveOnly}
//             onChange={handleToggle}
//             onColor="#86d3ff"
//             onHandleColor="#2693ee"
//             handleDiameter={24}
//             uncheckedIcon={false}
//             checkedIcon={false}
//             boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
//             activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
//             height={28}
//             width={56}
//             className="react-switch"
//           />
//         </div>
//       </div>

//       <GenericTable
//         columns={columns}
//         rows={rows}
//         rowKeyField="id"
//         loading={false}
//         loaderAnimation={loaderAnimation}
//         onRowClick={onRowClick}
//       />

//       {allAgreements && !loading && !error && (
//         <p className="text-center text-gray-500 py-4 text-sm">
//           Showing {rows.length} of {allAgreements.length} total agreements.
//         </p>
//       )}

//       {allAgreements && allAgreements.length === 0 && !loading && !error && (
//         <p className="text-gray-500 text-center py-10">
//           No agreements available.
//         </p>
//       )}
//     </div>
//   );
// }

// export default Agreements;

import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAgreementContext } from "./AgreementContext"; // Corrected import path
import { useAuth } from "../../Utility/AuthProvider";
import Lottie from "lottie-react";
import loaderAnimation from "../../assets/animations/loader.json";
import GenericTable from "../GenericTable"; // Assuming GenericTable is in a sibling folder
import Switch from "react-switch";
import Filters from "../Common/Filter"; // Assuming Filters is in a subfolder

function Agreements() {
  const { jwt } = useAuth();
  const navigate = useNavigate();

  // --- CONTEXT CONSUMPTION ---
  const { allAgreements, loading, error, fetchAllAgreements } =
    useAgreementContext();

  // --- LOCAL STATE ---
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [activeFilters, setActiveFilters] = useState({
    buildingIds: [],
    unitIds: [],
    tenantIds: [],
  });

  // Set the initial sort state to 'vacating_on' in ascending order
  const [sortConfig, setSortConfig] = useState({
    key: "vacating_on",
    direction: "ascending",
  });

  // --- DATA FETCH TRIGGER ---
  useEffect(() => {
    if (jwt) {
      fetchAllAgreements();
    }
  }, [jwt, fetchAllAgreements]);

  // --- FILTER & SORT HANDLERS ---
  const handleFilterChange = useCallback((newFiltersFromChild) => {
    setActiveFilters(newFiltersFromChild);
  }, []);

  const handleToggle = (checked) => {
    setShowActiveOnly(checked);
  };

  const handleClearAllFilters = () => {
    setSearchQuery("");
    setActiveFilters({ buildingIds: [], unitIds: [], tenantIds: [] });
  };

  // This function is called by GenericTable when a sortable header is clicked
  const handleRequestSort = (key) => {
    let direction = "ascending";
    // If the same column is clicked again, toggle the direction
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  // Memoized count of active filters for display
  const activeFilterCount = useMemo(() => {
    let count = 0;
    if (searchQuery.trim()) count++;
    count += Object.values(activeFilters).filter(
      (arr) => arr.length > 0
    ).length;
    return count;
  }, [searchQuery, activeFilters]);

  // --- COMBINED FILTERING AND SORTING LOGIC ---
  const processedAgreements = useMemo(() => {
    if (!allAgreements) return [];

    // 1. FILTERING
    let filteredData = [...allAgreements];
    if (searchQuery) {
      const lowercasedQuery = searchQuery.toLowerCase();
      filteredData = filteredData.filter(
        (a) =>
          a.building_name?.toLowerCase().includes(lowercasedQuery) ||
          a.unit_name?.toLowerCase().includes(lowercasedQuery)
      );
    }
    if (showActiveOnly) {
      filteredData = filteredData.filter((a) => a.active === true);
    }
    if (activeFilters.buildingIds.length > 0) {
      filteredData = filteredData.filter((a) =>
        activeFilters.buildingIds.includes(a.building_id)
      );
    }
    if (activeFilters.unitIds.length > 0) {
      filteredData = filteredData.filter((a) =>
        activeFilters.unitIds.includes(a.unit_id)
      );
    }

    // 2. SORTING (applied after filtering)
    if (sortConfig.key) {
      filteredData.sort((a, b) => {
        const valA = a[sortConfig.key];
        const valB = b[sortConfig.key];

        // Handle potential null/undefined values for robustness
        if (valA === null || valA === undefined) return 1;
        if (valB === null || valB === undefined) return -1;

        // Date comparison
        const dateA = new Date(valA);
        const dateB = new Date(valB);

        if (dateA < dateB) return sortConfig.direction === "ascending" ? -1 : 1;
        if (dateA > dateB) return sortConfig.direction === "ascending" ? 1 : -1;

        // Fallback sort: if dates are equal, sort by creation date to maintain a stable order
        const secondaryDateA = new Date(a.created);
        const secondaryDateB = new Date(b.created);
        return secondaryDateB - secondaryDateA; // Most recent first
      });
    }

    return filteredData;
  }, [allAgreements, showActiveOnly, activeFilters, searchQuery, sortConfig]);

  // --- HELPER & CONFIGS ---
  const calculateTenure = (createdDate, vacatingDate) => {
    const start = new Date(createdDate);
    const end = new Date(vacatingDate);
    let years = end.getFullYear() - start.getFullYear();
    let months = end.getMonth() - start.getMonth();

    if (months < 0) {
      years--;
      months += 12;
    }

    return `${years > 0 ? `${years} yr ` : ""}${months > 0 ? `${months} mos` : years === 0 ? "0 mos" : ""}`.trim();
  };

  const columns = [
    { id: "serialNo", label: "Record No.", minWidth: 80 },
    { id: "buildingName", label: "Building", minWidth: 150 },
    { id: "unitName", label: "Unit", minWidth: 120 },
    { id: "tenure", label: "Tenure", minWidth: 120 },
    { id: "created", label: "Created On", minWidth: 110, sortable: true },
    { id: "vacating_on", label: "Vacating On", minWidth: 110, sortable: true },
    { id: "updated", label: "Last Updated", minWidth: 110, sortable: true },
    { id: "status", label: "Status", minWidth: 100 },
  ];

  // Use the final `processedAgreements` to create the rows
  const rows = processedAgreements.map((agreement, index) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const vacatingDate = new Date(agreement.vacating_on);
    const isPast = vacatingDate < today;
    const vacatingColor = isPast && !agreement.active ? "red" : "inherit";

    return {
      ...agreement,
      serialNo: index + 1,
      buildingName: agreement.building_name || "N/A",
      unitName: agreement.unit_name || "N/A",
      tenure: calculateTenure(agreement.created, agreement.vacating_on),
      // The key MUST match the column `id` for sorting to work correctly
      created: new Date(agreement.created).toLocaleDateString(),
      vacating_on: (
        <span style={{ color: vacatingColor }}>
          {new Date(agreement.vacating_on).toLocaleDateString()}
        </span>
      ),
      updated: agreement.updated
        ? new Date(agreement.updated).toLocaleDateString()
        : "N/A",
      status: (
        <span style={{ color: agreement.active ? "green" : "red" }}>
          {agreement.active ? "Active" : "Inactive"}
        </span>
      ),
    };
  });

  const onRowClick = (row) => {
    if (row && row.unit_id) {
      navigate(`/dashboard/my-properties/${row.unit_id}`);
    } else {
      console.error("Row click failed: Missing unit_id.", row);
      alert("Navigation failed: Unit information is missing.");
    }
  };

  // --- RENDER LOGIC ---
  if (loading && allAgreements === null) {
    return (
      <div className="flex justify-center items-center h-64">
        <Lottie
          animationData={loaderAnimation}
          style={{ width: 150, height: 150 }}
        />
      </div>
    );
  }

  if (error) {
    return <p className="text-red-500 text-center py-10 text-lg">{error}</p>;
  }

  return (
    <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
      <div className="filters-container bg-gray-50 rounded-lg border p-4 mb-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <h3 className="text-lg font-medium">Filters</h3>
            {activeFilterCount > 0 && (
              <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                {activeFilterCount} active
              </span>
            )}
          </div>
          {activeFilterCount > 0 && (
            <button
              onClick={handleClearAllFilters}
              className="text-sm font-medium text-red-600 hover:text-red-800"
            >
              Clear All
            </button>
          )}
        </div>

        <div className="mb-4">
          <input
            type="text"
            placeholder="Search by building or unit name..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <Filters
          onFilterChange={handleFilterChange}
          selectedFilters={activeFilters}
          availableFilters={["building", "unit"]}
        />

        <div className="border-t mt-4 pt-4 flex items-center">
          <span className="mr-4 text-sm text-gray-700 font-medium">
            Agreement Status:
          </span>
          <span className="mr-2 text-sm text-gray-600">Show Active Only</span>
          <Switch
            checked={showActiveOnly}
            onChange={handleToggle}
            onColor="#86d3ff"
            onHandleColor="#2693ee"
            handleDiameter={24}
            uncheckedIcon={false}
            checkedIcon={false}
            height={28}
            width={56}
            className="react-switch"
          />
        </div>
      </div>

      <GenericTable
        columns={columns}
        rows={rows}
        rowKeyField="id"
        loading={loading}
        loaderAnimation={loaderAnimation}
        onRowClick={onRowClick}
        sortConfig={sortConfig} // Pass the current sort config
        requestSort={handleRequestSort} // Pass the sort handler function
      />

      {allAgreements && !loading && !error && (
        <p className="text-center text-gray-500 py-4 text-sm">
          Showing {rows.length} of {processedAgreements.length} matching
          agreements.
        </p>
      )}

      {processedAgreements.length === 0 && !loading && !error && (
        <p className="text-gray-500 text-center py-10">
          No agreements match the current filters.
        </p>
      )}
    </div>
  );
}

export default Agreements;
